<template>
   <div>
      <v-card class="bg-secondary" :height="height" :max-height="height">

         <v-toolbar dense class="bg-secondary">
            <slot name="title">
               <h4 class="mb-0">???</h4>
            </slot>
            <v-spacer></v-spacer>
            <slot name="dropdown">
            </slot>
         </v-toolbar>

         <v-container class="bg-secondary">

            <slot name="header">
               <h4 class="mb-0">values.value</h4>
            </slot>
            
            <slot name="message">
               <p>values.message</p>
            </slot>

            <slot name="graph">
               <span>&nbsp;</span>
            </slot>
         </v-container>

      </v-card>
   </div>
</template>

<script>
import ddoAlert from '@/components/ddoAlert.vue';

export default {
   name: 'TileSimple',
   components: {
      ddoAlert
   },

   props: {
      height: 280,
      body_style: "height: 80px",
      backgroundcolor : "bg-secondary",
      values: Object
   },

   data: function () {
      return {
      }
   },

   created() {
      //this.background_color = "bg-secondary";
    },

}
</script>